import axios, { AxiosInstance } from 'axios'

export const http: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
  //   paramsSerializer: function (params) {
  //     return qs.stringify(params, { indices: false });
  //   },
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      //logoutBy401()
      switch (error.response.config.url) {
        case '/v2/account/transfer-token-confirmation':
        case '/v2/email-confirmation':
        case '/v2/reset-password':
          break
        default:
          console.error('API 401, go signin page.')
          return (window.location.href = '/signin')
      }
    }
    console.log('axios interceptors error: ', JSON.stringify(error, null, 4))
    return Promise.reject(error)
  }
)

export const setAuthTokenHeader = (token: string | undefined) => {
  if (token) {
    http.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete http.defaults.headers.common['Authorization']
  }
}

export interface SuccessResponseV1<T> {
  code: string
  data: T
  msg: string
}

export interface FailedResponseV1 {
  code: string
  msg: string
}
